module.exports = __webpack_public_path__ + "img/icon-Social7.50565f1d.png";